<template>
    <div class="back-perfil height-senha">
        <div class="container pb-5 px-2">

            <div class="criar-conta mt-4">
                <h2 class="text-center text-white"><strong>Redefinir Senha</strong></h2>

                <div class="dados-conta bg-white mt-5 mt-md-3 rounded p-2 shadow">
                    <div class="wizard my-0 mx-auto m-md-3">

                        <div class="media-body pr-md-4">
                            <div v-if="!senhaAlterada">
                                <div class="dados-conta bg-white mt-3 ">
                                    <form ref="form-redefinir-senha" class="form-group">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group form-group-custom">
                                                    <label for="senhaAtual" class="bmd-label-floating">Senha Atual</label>
                                                    <input type="password" class="form-control" name="senhaAtual" v-model="model.senhaAtual" placeholder="Informe a Senha Atual" required>
                                                </div>
                                                <div class="form-group">
                                                    <label for="senha">Nova Senha</label>
                                                    <input type="password" class="form-control" name="senha" v-model="model.senha" placeholder="Informe a Nova Senha" required>
                                                </div>
                                                <div class="form-group">
                                                    <label for="confirmacao">Confirmar Nova Senha</label>
                                                    <input type="password" class="form-control" name="confirmacao" v-model="model.confirmacao" placeholder="Informe a Confirmação da Senha" required>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mt-4">
                                                <div class="alert alert-secondary text-center">
                                                    <strong>Dica de segurança</strong><br />
                                                    <span class="small">Crie uma senha com no mínimo 6 caracteres. <!--Você <strong>deve</strong> usar letras, maiúsculas, números ou caracteres especiais (como $, #, @).--></span>
                                                </div>
                                            </div>


                                            <div class="row col-md-12 mt-3">
                                                <div class="col-6 ">
                                                    <!--<button type="button" class="btn btn-danger border-primary rounded-pill previous-button px-4" @click="onBack()">Voltar</button>-->
                                                </div>
                                                <div class="col-6 text-right">
                                                    <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill enviar-codigo px-4" @click="alteraSenha()">Continuar</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div v-if="senhaAlterada">
                                <h2 class="text-center text-white"><strong>Sua senha foi alterado com sucesso!.</strong></h2>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
    import base from '@/common/base.js'
    import Global from '@/common/global'
    import { Api } from '@/common/api'

    export default {
        name: 'redefinir-senha',
        mixins: [base],
        data: () => ({
            id: null,
            senhaAlterada: false,
            model: {},
            result: {},

        }),
        mounted() {
            this.id = this.$route.params.id;
        },
        methods: {
            fecharJanela() {
                window.top.close();
            },
            alteraSenha() {
                if (this.formValidate() == false)
                    return;

                this.showLoading();
                this.model.pessoaCNAId = this.id;

                new Api('pessoacnaacesso/NovaSenhaUsuario').get(this.model).then(result => {
                    this.result = result.data;
                    this.hideLoading();

                    this.$swal({
                        type: 'success',
                        title: 'Senha Alterada',
                        text: 'Senha Alterada com sucesso!',
                        modal: true,
                        onAfterClose: () => {
                            console.log("aqui");
                            this.senhaAlterada = true;
                        },
                    });

                }, err => {
                    this.hideLoading();
                    this.$eventHub.$emit('show-notification', {
                        type: 'error',
                        title: 'Atenção',
                        text: err.data.errors.join(),
                        modal: true,
                        html: true,
                    });
                })
            },

            formValidate: function () {
                var $form = this.$refs["form-redefinir-senha"];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

        },
    };
</script>

|
<style>
    .height-senha {
        height: calc(100vh - 76px) !important;
    }
</style>